import _, { useState as g, useEffect as E } from "react";
import { SelectField as F } from "@amenitiz/design-system";
import { FieldState as S } from "./index196.mjs";
const h = ({
  id: r,
  options: s,
  selectedOption: t,
  disabled: i = !1,
  required: d = !1,
  label: e,
  onChange: o,
  state: l = S.DEFAULT,
  name: c,
  placeholder: f = I18n.t("booking_engine.information.select_option"),
  "data-testid": m
}) => {
  const [p, a] = g("");
  E(() => {
    a(t || "");
  }, [t]);
  const u = (n) => {
    a(n), o && o(n);
  };
  return /* @__PURE__ */ _.createElement(
    F,
    {
      autocomplete: !0,
      classes: "be-dropdown",
      id: r,
      name: c,
      label: e,
      value: p,
      options: s,
      onChange: u,
      placeholder: f,
      required: d,
      disabled: i,
      state: l,
      "data-testid": m,
      title: e
    }
  );
};
export {
  h as Dropdown
};
